module.exports = __webpack_public_path__ + "img/bnr-spring2022-pc.1ebaeb4b.jpg";